import { format } from '@querodelivery/qd-date-helper';
import isEmpty from 'lodash/isEmpty';
import { createPortal } from 'react-dom';

import useModal from '@/hooks/util/useModal';
import type { IPlaceMinimalFareInfo } from '@/Interfaces/Data';
import { paymentMethods } from '@/static/FranchiseConstants';
import { convertMetersToKilometers, moneyLabel } from '@/Utils/FnUtils';
import styles from './styles.module.scss';
import { FARE_OF_TYPE_LABEL } from '@/features/fare/types';

interface IProps {
  onClose(): void;
  place: IPlaceMinimalFareInfo;
}

function PlaceFareModal({ onClose, place }: IProps) {
  const Modal = useModal({ maxHeight: undefined });

  if (!place.placeFare) {
    return null;
  }

  const formattedFareOfType = place.placeFare.fareOfType
    ? FARE_OF_TYPE_LABEL[place.placeFare.fareOfType]
    : '';

  const createdAtToShow = place.placeFare?.createdAt ?? place.createdAt;

  return createPortal(
    <Modal
      open
      onClose={onClose}
      title="Detalhes da franquia"
      closeOnDimerClick
    >
      <table className={styles.tableContainer}>
        <tbody>
          <tr>
            <td>
              <b>Id</b>
            </td>
            <td>{place._id}</td>
          </tr>
          <tr>
            <td>
              <b>Nome</b>
            </td>
            <td>{place.nomeExibicao}</td>
          </tr>
          <tr>
            <td>
              <b>Data de criação</b>
            </td>
            <td>{format(new Date(createdAtToShow), 'dd/MM/yyyy HH:mm')}</td>
          </tr>
          <tr>
            <td>
              <b>Distância da entrega base</b>
            </td>
            <td>
              {convertMetersToKilometers(place.placeFare.entregaBaseMts)} Km
            </td>
          </tr>
          <tr>
            <td>
              <b>Valor da entrega base</b>
            </td>
            <td>{moneyLabel(place.placeFare.valorEntregaBase)}</td>
          </tr>
          <tr>
            <td>
              <b>Distância limite para 2 entregas</b>
            </td>
            <td>
              {convertMetersToKilometers(
                place.placeFare.maxDistanceDropsToGroup,
              )}{' '}
              Km
            </td>
          </tr>
          <tr>
            <td>
              <b>Valor taxa Km adicional</b>
            </td>
            <td>{moneyLabel(place.placeFare.taxaEntregaKmAdicional)}</td>
          </tr>
          <tr>
            <td>
              <b>Distância entregador / estabelecimento</b>
            </td>
            <td>
              {convertMetersToKilometers(place.placeFare.raioMaxDistance)} Km
            </td>
          </tr>
          <tr>
            <td>
              <b>Valor Km adicional</b>
            </td>
            <td>{moneyLabel(place.placeFare.valorKmAdicional)}</td>
          </tr>
          <tr>
            <td>
              <b>Quantidade de entregas por corrida</b>
            </td>
            <td>{place.placeFare.qtdMaxEntregaGroup}</td>
          </tr>
          <tr>
            <td>
              <b>Distância mínima do estabelecimento para concluir corrida</b>
            </td>
            <td>
              {convertMetersToKilometers(
                place.placeFare.minDistanceCloseTo || 0,
              )}
            </td>
          </tr>
          <tr>
            <td>
              <b>Obrigatório entregador próximo ao estabelecimento?</b>
            </td>
            <td>
              {place.placeFare.requiredNearPlaceToConfirm ? 'Sim' : 'Não'}
            </td>
          </tr>
          <tr>
            <td>
              <b>Quantidade de entregas por corrida</b>
            </td>
            <td>{place.placeFare.qtdMaxEntregaGroup}</td>
          </tr>
          <tr>
            <td>
              <b>Retorno obrigatório</b>
            </td>
            <td>
              {isEmpty(place.placeFare.requiredReturnToConfirmPayMethods)
                ? 'Nenhum'
                : place.placeFare.requiredReturnToConfirmPayMethods.map(
                    (paymentForm, index) =>
                      `${index !== 0 ? ', ' : ''}${
                        paymentMethods[paymentForm]
                      }`,
                  )}
            </td>
          </tr>
          <tr>
            <td>
              <b>Tipo de tarifa</b>
            </td>
            <td>{formattedFareOfType}</td>
          </tr>
        </tbody>
      </table>
    </Modal>,
    document.body,
  );
}

export default PlaceFareModal;
